import { TranslationDict } from "../types";

export const enSettings: TranslationDict = {
  instellingen: "Settings",
  gebruikPaketten: "Use packages",
  infoPakettenAan1: "Checked, we will use packages if applicable.",
  infoPakettenAan2: "Unchecked, we will use individual modules.",

  gebruikEnkelSa: "Use only REL04SA modules (no REL08)",
  infoSaAan1: "Checked, we will use only the 'Stand Alone' relay module.",
  infoSaAan2: "Unchecked, we will also use a REL08 module.",

  upgradeController: "Upgrade controller at x addresses",
  infoUpgradeController1: "A ctd can use a maximum of 388.",
  infoUpgradeController2: "Set here at which number of addresses an additional controller should be added.",
  
  standaardUitvoering: "Standard execution",
  infoStandaardUitvoering: "Set here the finish of your buttons.",

  taal: "Language",
  infoTaal: "Set your preferred language here.",
};